// src/theme/tokens/reading.js
// Faz 1 · Uzun-form okuma (ders, makale, lecture) icin semantic tokens.
// LectureViewPage ve .ders-container icin yeni standart.
// Faz 4'te theme/styles.js'deki .ders-container hardcoded hex'leri buraya migre olur.

const readingTokens = {
  // ===== SURFACE =====
  'reading.bg':           { default: 'white',     _dark: 'slate.850' },
  'reading.bgSubtle':     { default: 'slate.25',  _dark: 'slate.900' },
  'reading.border':       { default: 'slate.100', _dark: 'slate.800' },
  'reading.cardBg':       { default: 'white',     _dark: 'slate.800' },

  // ===== TEXT =====
  // Reading-optimized contrast · uzun okuma yorgunlugunu azaltir.
  'reading.text':         { default: '#1F2A37',   _dark: '#E6EAEF' },
  'reading.textSecondary':{ default: '#4B5563',   _dark: '#A8B3BF' },
  'reading.textMuted':    { default: '#6B7280',   _dark: '#7B8794' },
  'reading.heading':      { default: '#0F1419',   _dark: '#F4F6F8' },
  'reading.subheading':   { default: '#1F2A37',   _dark: '#CFD6DE' },

  // ===== ACCENTS =====
  'reading.accent':       { default: 'brand.600', _dark: 'brand.300' },
  'reading.link':         { default: 'brand.600', _dark: 'brand.300' },
  'reading.linkHover':    { default: 'brand.700', _dark: 'brand.200' },
  'reading.linkUnderline':{ default: 'brand.500_alpha_40', _dark: 'brand.300_alpha_40' },

  // ===== HIGHLIGHT (mark, vurgu) =====
  'reading.highlight.yellow': { default: 'amber.100', _dark: 'amber.900' },
  'reading.highlight.green':  { default: 'emerald.100', _dark: 'emerald.900' },
  'reading.highlight.pink':   { default: 'rose.100', _dark: 'rose.900' },
  'reading.highlight.blue':   { default: 'brand.100', _dark: 'brand.900' },
  'reading.highlight.text':   { default: 'slate.900', _dark: 'slate.50' },

  // ===== BLOCKQUOTE =====
  'reading.quote.bg':       { default: 'slate.50',  _dark: 'slate.800' },
  'reading.quote.border':   { default: 'brand.500', _dark: 'brand.300' },
  'reading.quote.text':     { default: 'slate.700', _dark: 'slate.200' },

  // ===== CODE =====
  'reading.code.inlineBg':  { default: 'slate.100', _dark: 'slate.800' },
  'reading.code.inlineText':{ default: 'rose.600',  _dark: 'rose.300' },
  'reading.code.blockBg':   { default: 'slate.50',  _dark: 'slate.900' },
  'reading.code.blockText': { default: 'slate.800', _dark: 'slate.100' },
  'reading.code.blockBorder':{ default: 'slate.200', _dark: 'slate.800' },

  // ===== TABLE =====
  'reading.table.headerBg':   { default: 'slate.50',  _dark: 'slate.800' },
  'reading.table.headerText': { default: 'slate.700', _dark: 'slate.100' },
  'reading.table.rowBg':      { default: 'transparent', _dark: 'transparent' },
  'reading.table.rowAltBg':   { default: 'slate.25',  _dark: 'slate.900' },
  'reading.table.rowHoverBg': { default: 'brand.25',  _dark: 'slate.700' },
  'reading.table.border':     { default: 'slate.200', _dark: 'slate.700' },

  // ===== INFO BOXES (lecture template · info, tip, warning, danger, mechanism, stat) =====
  // CLAUDE.md'deki info-box / mechanism-box / tip-box / warning-box / danger-box / stat-box
  'reading.box.info.bg':       { default: 'brand.50',   _dark: 'brand.900' },
  'reading.box.info.border':   { default: 'brand.200',  _dark: 'brand.700' },
  'reading.box.info.icon':     { default: 'brand.500',  _dark: 'brand.300' },
  'reading.box.info.title':    { default: 'brand.700',  _dark: 'brand.200' },

  'reading.box.mechanism.bg':     { default: 'indigo.50',  _dark: 'indigo.900' },
  'reading.box.mechanism.border': { default: 'indigo.200', _dark: 'indigo.700' },
  'reading.box.mechanism.icon':   { default: 'indigo.500', _dark: 'indigo.300' },
  'reading.box.mechanism.title':  { default: 'indigo.700', _dark: 'indigo.200' },

  'reading.box.tip.bg':       { default: 'emerald.50',  _dark: 'emerald.900' },
  'reading.box.tip.border':   { default: 'emerald.200', _dark: 'emerald.700' },
  'reading.box.tip.icon':     { default: 'emerald.500', _dark: 'emerald.300' },
  'reading.box.tip.title':    { default: 'emerald.700', _dark: 'emerald.200' },

  'reading.box.warning.bg':       { default: 'amber.50',   _dark: 'amber.900' },
  'reading.box.warning.border':   { default: 'amber.200',  _dark: 'amber.700' },
  'reading.box.warning.icon':     { default: 'amber.500',  _dark: 'amber.300' },
  'reading.box.warning.title':    { default: 'amber.700',  _dark: 'amber.200' },

  'reading.box.danger.bg':       { default: 'rose.50',   _dark: 'rose.900' },
  'reading.box.danger.border':   { default: 'rose.200',  _dark: 'rose.700' },
  'reading.box.danger.icon':     { default: 'rose.500',  _dark: 'rose.300' },
  'reading.box.danger.title':    { default: 'rose.700',  _dark: 'rose.200' },

  'reading.box.stat.bg':       { default: 'teal.50',   _dark: 'teal.900' },
  'reading.box.stat.border':   { default: 'teal.200',  _dark: 'teal.700' },
  'reading.box.stat.icon':     { default: 'teal.500',  _dark: 'teal.300' },
  'reading.box.stat.title':    { default: 'teal.700',  _dark: 'teal.200' },
};

export default readingTokens;
